import React from 'react';
import { Alert } from 'react-bootstrap';
import { useCheckIn } from '../../hooks/useCheckIn';

const ErrorAlert: React.FC = () => {
  const { state } = useCheckIn();

  if (!state.error) {
    return null;
  }

  return (
    <Alert variant="danger" className="mb-4">
      {state.error}
    </Alert>
  );
};

export default ErrorAlert;